/**
* User management & login
*/
module.config(['$stateProvider', 'urls', function ($stateProvider, urls) {
    'use strict';
    $stateProvider
        .state('admin', {
            url: '/admin', // TODO : translate or not ?
            controller: function ($state) {
                $state.go('login');
            }
        })
        .state('user', {
            url: '/' + urls.user.fr + '/{id:int}', // TODO : when multilang, change this to something dynamic
            controller: function ($state) {
                $state.go('login');
            }
        })
        .state('login', {
            url: '/' + urls.user.fr + '/' + urls.user.login.fr, // TODO : when multilang, change this to something dynamic
            resolve: {
                auth: ['$q', 'profile', function ($q, $profile) {
                    console.log('login: retrieve user');

                    var deferred = $q.defer();

                    $profile.claim().then(function (authorization) {
                        if (authorization.authenticated) {
                            if (!authorization.role) {
                                deferred.reject({ status: 'ACCOUNT_LOGIN__DISCONNECT' });
                            } else if (authorization.role === 'member' || authorization.role === 'administrateur' || authorization.role === 'instructor' || authorization.role === 'rtq') {
                                deferred.reject({ status: 'ACCOUNT_LOGIN__ALREADY' });
                            } else {
                                deferred.reject({ status: 'ACCOUNT_LOGIN__ADMIN' });
                            }
                        } else {
                            deferred.resolve(authorization);
                        }
                    }).catch(function (error) {
                        deferred.reject({ status: 'ACCOUNT_LOGIN__ERROR' });
                    });
                    return deferred.promise;
                }]
            },
            controller: ['$scope', '$rootScope', '$state', '$document', '$filter', 'drupal', 'profile', '$window', 'headermanager', 'moment', 'drupal', 'tools', 'formPattern', 'utils', function ($scope, $rootScope, $state, $document, $filter, $drupal, $profile, $window, $headermanager, moment, drupal, $tools, formPattern, utils) {
                // choose between two layout
                $scope.type = $rootScope.site.id === 'avenir' ? 'simple' : 'extended';
                $scope.tools = $tools;
                $scope.formPattern = formPattern;

                $headermanager.customize({
                    filled: true,
                    type: 'alternate'
                });
                $scope.optionsCivility = [
                    { text: $filter('translate')('form.male'), value: 'M.' },
                    { text: $filter('translate')('form.female'), value: 'Mme' }
                ];
                // page title
                $scope.title = $filter('translate')('account.signinTitle');

                // prepare credentials
                $scope.credentials = {
                    loading: false,
                    name: '',
                    pass: ''
                };

                function callIfDefined(name, args) {
                    if ($scope[name]) {
                        $scope[name].apply(null, args || []);
                    }
                }

                $scope.login = function() {
                    return drupal.authenticate($scope.credentials).then(function() {
                        callIfDefined('onLoginSuccess')
                    });
                };

                $scope.onLoginSuccess = function() {
                    // reload state to determine if routing to admin or member state
                    // (see $profile.claim above)
                    //$state.reload();

                    // reload page for live agent customer context
                    $window.location.reload();
                };

                $scope.onError = function(err) {
                    $scope.hasError = true;
                };

                $scope.onFinally = function() {
                    $scope.credentials.loading = false;
                };

                $scope.onSubmit = function() {
                    console.log('detect');
                    $scope.credentials.loading = true;
                };

                // prepare user creation
                $scope.user = {
                    loading: false,
                    email: '',
                    pass: '',
                    pass_confirmation: '',
                    firstname: '',
                    lastname: '',
                };
                $scope.legal_guardian = {
                    field_nom: '',
                    field_prenom: '',
                    field_civilite: '',
                    field_date_de_naissance: '',
                    mail: '',
                    field_tel_portable: ''
                }
                $scope.other_legal_guardian = {
                    field_nom: '',
                    field_prenom: '',
                    field_date_de_naissance: '',
                    mail: '',
                    field_tel_portable: ''
                }
                $scope.errors = {
                    message: ''
                };

                // TODO: create if member.field_nom is undefined ; update otherwise
                $scope.create = function (isValid) {
                    $scope.user.loading = true;
                    angular.merge($scope.errors, { message: '' });
                    if (isValid) {
                        $drupal.createAccount({
                            email: $scope.user.email,
                            pass: $scope.user.pass,
                            lastname: $scope.user.lastname,
                            firstname: $scope.user.firstname,
                            birth_date: moment($scope.user.birth_date, ["DD/MM/YYYY", "YYYY-MM-DD"]).format("YYYY-MM-DD"),
                            legal_guardian: {
                                field_nom: $scope.legal_guardian.field_nom,
                                field_prenom: $scope.legal_guardian.field_prenom,
                                field_date_de_naissance: $scope.legal_guardian.field_date_de_naissance ? moment($scope.legal_guardian.field_date_de_naissance, ["DD/MM/YYYY", "YYYY-MM-DD"]).format("YYYY-MM-DD") : '',
                                mail: $scope.legal_guardian.mail,
                                salutation: $scope.legal_guardian.field_civilite,
                                field_tel_portable: $scope.legal_guardian.field_tel_portable,
                            },
                            other_legal_guardian: {
                                field_nom: $scope.other_legal_guardian.field_nom,
                                field_prenom: $scope.other_legal_guardian.field_prenom,
                                field_date_de_naissance: $scope.legal_guardian.field_date_de_naissance ? moment($scope.other_legal_guardian.field_date_de_naissance, ["DD/MM/YYYY", "YYYY-MM-DD"]).format("YYYY-MM-DD") : '',
                                mail: $scope.other_legal_guardian.mail,
                                field_tel_portable: $scope.other_legal_guardian.field_tel_portable,
                            }
                        }).then(function (result) {
                            if (result.code === 0) {
                                // createAccount open user session so we redirect him to his account management
                                $state.go('member.info.profil.editcoordinate');
                            } else {
                                // ws return error message
                                angular.merge($scope.errors, { message: result.message });
                            }
                        }).catch(function (error) {
                            console.log('createAccount error', error);
                            if (error.data && error.data.message) {
                                // ws return error message
                                if (error.data.code === 1) {
                                    angular.merge($scope.errors, { message: $filter('translate')('account.emailAlreadyExists') });
                                } else if (error.data.message) {
                                    angular.merge($scope.errors, { message: error.data.message });
                                } else {
                                    angular.merge($scope.errors, { message: $filter('translate')('server.notResponding') });
                                }
                            }
                        }).finally(function () {
                            $scope.user.loading = false;
                        });
                    } else {
                        $scope.user.loading = false;
                    }
                };

                utils.calendarTrad();

                // forgot password link
                $scope.forgot = function () {
                    $state.go('userforgot', { email: $scope.credentials.name });
                };
                $scope.initdatepicker = function(){
                    utils.calendarTrad();
                }
            }],
            templateUrl: 'src/views/admin/user_login.html'
        })
        .state('userforgot', {
            url: '/utilisateur/changer-mot-de-passe',
            params: {
                email: null,
                errorMessage: null
            },
            controller: ['$rootScope', '$scope', '$stateParams', 'headermanager', '$filter', 'tools', 'drupal', function ($rootScope, $scope, $stateParams, $headermanager, $filter, tools, drupal) {
                $headermanager.customize({
                    filled: true,
                    type: 'alternate'
                });

                $scope.title = $filter('translate')('account.forgotPasswordTitle');

                resetForm();

                $scope.form = {
                    email: ($stateParams.email || '')
                };

                if ($stateParams.errorMessage) {
                    $scope.error = $stateParams.errorMessage;
                }

                function resetForm() {
                    $scope.form = {
                        email: ''
                    };

                    $scope.done = false;
                    $scope.loading = false;

                    $scope.account = null;
                    $scope.accounts = [];
                    $scope.showAccountSelect = false;
                }

                function sendMail() {
                    return drupal.retrievePassword($scope.account).then(function (result) {
                        if (result.status === 'OK') {
                            $scope.done = true;
                            $scope.error = undefined;
                            $scope.successMessage = tools.replace($filter('translate')('account.forgotPasswordResult'), { email: $scope.form.email });
                        } else {
                            $scope.error = result.message;
                        }
                    });
                }

                function getAccounts() {
                    $scope.account = null;

                    return drupal.getAccountsByEmail($scope.form.email).then(function(data) {
                        $scope.accounts = data;

                        switch ($scope.accounts.length) {
                            case 0:
                               throw new Error('Not accound found for this email');
                            case 1:
                                $scope.showAccountSelect = false;
                                $scope.account = data[0].name;
                                break;
                            default:
                                $scope.showAccountSelect = true;
                                break;
                        }
                    });
                }

                function getAction() {
                    // if an account is setted, send email
                    if ($scope.account) {
                        return sendMail();
                    }

                    return getAccounts().then(function () {
                        // In case of one account per email, send email
                        if ($scope.account) {
                            return sendMail();
                        }
                    });
                }

                $scope.submit = function(isValid) {
                    if (!isValid) {
                        return
                    }

                    $scope.error = undefined;
                    $scope.loading = true;

                    getAction().catch(function (error) {
                        $scope.error = $filter('translate')('server.notRespondingCheckEmail');
                    }).finally(function () {
                        $scope.loading = false;
                    });
                }

                $scope.onAccountChange = function(account) {
                    $scope.account = account.name;
                }

                $scope.previous = resetForm;
            }],
            templateUrl: 'src/views/admin/user_forgot.html'
        })
        .state('userchangepwd', {
            url: '/utilisateur/changer-mot-de-passe' + '/{uid}/{tmstp}/{token}', // TODO : when multilang, change this to something dynamic
            resolve: {
                tokenvalidation: ['$stateParams', 'drupal', function ($stateParams, $drupal) {
                    // check token validation
                    return $drupal.checkToken($stateParams.uid, $stateParams.tmstp, $stateParams.token)
                        .catch(function (error) {
                            throw { status: 'ACCOUNT_CHANGE_PASSWORD_INVALID_TOKEN' };
                        });
                }]
            },
            controller: ['$rootScope', '$stateParams', '$state', '$scope', 'headermanager', '$filter', 'drupal', function ($rootScope, $stateParams, $state, $scope, $headermanager, $filter, $drupal) {
                //
                $headermanager.customize({
                    filled: true,
                    type: 'alternate'
                });

                $scope.title = $filter('translate')('account.changePasswordTitle');

                // prepare vm
                $scope.user = {
                    email: '',
                    pass: '',
                    pass_confirmation: '',
                };
                $scope.errors = {
                    message: '',
                };

                $scope.changePassword = function (isValid) {
                    if (isValid) {
                        $scope.loading = true;
                        $drupal.changePassword({
                            token: $stateParams.token,
                            login: $stateParams.uid,
                            password: $scope.user.pass,
                        }).then(function () {
                            swal({
                              title: $filter('translate')('form.newPasswordConfirmationTitle'),
                              text: $filter('translate')('form.newPasswordConfirmationText'),
                              icon: 'success'
                            }).then(function () {
                                $state.go('login');
                            });
                        }).catch(function () {
                            // TODO: add error message (via $scope.errors.message) if token do not match with login/email

                            // default error message
                            $scope.error = $filter('translate')('server.notResponding');
                        }).finally(function () {
                            $scope.loading = false;
                        });
                    }
                };
            }],
            templateUrl: 'src/views/admin/user_change_password.html'
        });
}]);
